import { useEnvironmentInterface } from "environment-interface";
import { CodeiumService } from "environment-interface/monacoEditor/browser/services/editor/vscode/vscode-extensions/codeium/codeium-service";
import { EditorHistoryService } from "environment-interface/monacoEditor/browser/services/editor/vscode/vscode-extensions/editor-history";
import { usePitcher } from "features/utils/usePitcher";
import { StandaloneServices, IEditorService } from "vscode/services";

import { useActiveWorkspaceSubscription } from "hooks/useActiveWorkspaceSubscription";
import { useScopedPersistedState } from "hooks/usePersistedState";
import { useVSCodeExtensionInitializedEffect } from "hooks/useVSCodeExtensionInitializedEffect";

import { useCodeiumModal } from "./useCodeiumModal";

export const EnableCodeium: React.FC<{ workspaceId: string }> = ({
  workspaceId,
}) => {
  const { monacoEditor } = useEnvironmentInterface();
  const editorState = monacoEditor.libraryState.state;
  const { open } = useCodeiumModal();
  const pitcher = usePitcher();

  const { isFree } = useActiveWorkspaceSubscription();

  const [, setCodeiumSandboxFreeUsage] = useScopedPersistedState(
    "CODEIUM_SANDBOX_FREE_USAGE",
    0,
    `${workspaceId}/${new Date().getMonth()}`,
  );

  useVSCodeExtensionInitializedEffect(() => {
    if (editorState === "LOADED") {
      const onAcceptSuggestion = () => {
        if (isFree) {
          setCodeiumSandboxFreeUsage((prev) => prev + 1);
        }
      };

      const historyService = new EditorHistoryService();
      const dispose = new CodeiumService(
        pitcher.currentClient.username,
        StandaloneServices.get(IEditorService),
        historyService,
        onAcceptSuggestion,
      );

      const disposeCommand =
        monacoEditor.libraryState.monaco.editor.registerCommand(
          "codeium.open",
          open,
        );

      return () => {
        dispose.dispose();
        disposeCommand.dispose();
        historyService.dispose();
      };
    }
  }, [editorState]);

  return null;
};
